// alphabetized
export enum BusinessOperatingSystem {
  ninetyOS = '90os',
  eos = 'EOS',
  empire = 'Empire',
  fireproof = 'Fireproof',
  pinnacle = 'Pinnacle',
}
